import { helper } from '@ember/component/helper';

export function or(params /*, hash*/) {
    let passes = false;

    for (let i = 0; i < params.length; i++) {
        if (params[i]) {
            passes = true;
            break;
        }
    }

    return passes;
}

export default helper(or);
